export class SecurityInterceptor {

  private readonly res: any;

  constructor(res?) {
    this.res = res;
  }

  getHost() {
    const hostname = window.location.hostname.split('.');
    // we only want the hostname without subdomain, detect if on vendor
    if (hostname.length > 1 && hostname[0] !== 'vendor' && hostname[0] !== 'awi-manage-account') {
      hostname.shift();
    }
    return hostname;
  }

  checkForRedirect() {
    if (this.res && this.res['request'] && this.res['request']['responseURL']) {
      const url = new URL(this.res['request']['responseURL']);
      const path = url.pathname;
      if (path === '/login') {
        this.checkSecurityRedirect();
      }
    } else {
      this.checkSecurityRedirect();
    }
  }

  private checkSecurityRedirect() {
    // wait until cookie populates
    if (document.cookie.indexOf('SECURITY_REDIRECT') > -1) {
      const hostname = this.getHost();
      document.cookie = 'SECURITY_REDIRECT=null; path=/; domain=' + hostname.join('.');
      document.cookie = 'SECURITY_REDIRECT=' + window.location.pathname + window.location.hash + '; path=/; domain=' + hostname.join('.');
      SecurityInterceptor.doRedirect();
    } else {
      SecurityInterceptor.doRedirect();
    }
  }

  static doRedirect() {
    setTimeout(() => {
      window.location.href = '/login';
    }, 300);
  }

  checkVendorLogin(cb) {
    if (this.res.data.userType && this.res.data.userType === 'VENDOR') {
      const host = this.getHost();
      const path = window.location.pathname.split('/').filter((i) => i).join('');
      if (host[0] !== 'vendor' && host[0] !== 'localhost' && host[0] !== 'awi-manage-account' && path !== 'awi-manage-account') {
        host.unshift('vendor');
        window.location.href = 'https://' + host.join('.');
      } else {
        return cb(false);
      }
    } else {
      return cb(false);
    }
  }

}
